import { SET_MAINTENANCE_SCHEDULE_READ, SET_MAINTENANCE_STATUS } from './maintenanceTypes';

const initialState = {
  startDate: window.MAINTENANCE_START_DATE,
  endDate: window.MAINTENANCE_END_DATE,
  isInProgress: false,
  isScheduled: false,
  isRead: false,
};

const MaintenanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_MAINTENANCE_SCHEDULE_READ: {
      return {
        ...state,
        isRead: true,
      };
    }
    case SET_MAINTENANCE_STATUS: {
      return {
        ...state,
        startDate: action.maintenance.startDate,
        endDate: action.maintenance.endDate,
        isInProgress: action.maintenance.isInProgress,
        isScheduled: action.maintenance.isScheduled,
      };
    }
    default:
      return state;
  }
};

export default MaintenanceReducer;
